export function stringCaseInsensitiveIgnoreWhitespaceEquals(a, b) {
    if (a == b) {
        return true;
    }
    
    if (a && b) {
        if (a.replace(/\s/g, "").toLowerCase() == b.replace(/\s/g, "").toLowerCase()) {
            return true;
        }
    }

    return false;
}